module.exports = __webpack_public_path__ + "img/dengji1.1728ef44.png";